import { render, staticRenderFns } from "./AgencyPageHeader.vue?vue&type=template&id=088b3fe2&scoped=true"
import script from "./AgencyPageHeader.vue?vue&type=script&lang=js"
export * from "./AgencyPageHeader.vue?vue&type=script&lang=js"
import style0 from "./AgencyPageHeader.vue?vue&type=style&index=0&id=088b3fe2&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088b3fe2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {S2PageHeader: require('/usr/src/app/node_modules/front-components/components/layout/PageHeader.vue').default,S2TabButtons: require('/usr/src/app/node_modules/front-components/components/ui/tab/TabButtons.vue').default})
